import { ROUTER_NAMES } from './routerNamesConfig';

export const COMPANY_CONSTRUCTORS = [
	{
		path: 'logistic-routes/:id',
		name: ROUTER_NAMES.LOGISTIC_ROUTES.CONSTRUCTOR,
		component: () => import('@/views/company/constructors/logistic-routes/CompanyConstructorLogisticRoutesView.vue'),
	},
]
